import { useTranslation } from "react-i18next";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  SimpleGrid,
  VStack,
  HStack,
  Divider,
  Box,
  FormLabel,
} from "@chakra-ui/react";
import { labelProps, readOnlyInputProps } from "./modalStyles";

const GenericViewModal = ({ title, fields, data, onClose }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  if (!data) return null;

  return (
    <Modal isOpen={true} onClose={onClose} size="4xl" dir={isRTL ? "rtl" : "ltr"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={6} align="stretch">
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
              {fields.map((f) => (
                <Box key={f.key} gridColumn={f.fullWidth ? { md: "span 2" } : undefined}>
                  <FormLabel {...labelProps}>{f.label}</FormLabel>
                  {f.render ? (
                    f.render(data)
                  ) : (
                    <Input {...readOnlyInputProps} value={data[f.key] ?? "-"} />
                  )}
                </Box>
              ))}
            </SimpleGrid>

            <Divider />

            <HStack justifyContent="flex-end">
              <Button
                type="button"
                colorScheme="gray"
                textTransform="capitalize"
                onClick={onClose}
              >
                {t("general.close")}
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default GenericViewModal;